export const isCellFilled = (value) => {
  const v = String(value ?? "").trim();
  if (v === "") return false;
  if (v === "-") return true;
  return /^\d*\.?\d+$/.test(v);
};

export const createSnapshot = (h2, ch4, co2, addInfo, notesVal) =>
  JSON.stringify({
    h2,
    ch4,
    co2,
    additionalInfo: addInfo,
    notes: notesVal ?? "",
  });
